export default __webpack_public_path__ + "57b390af3a691686a5b63d436960b56d.svg";